import { Alert as AlertSharedComponent, AlertProps } from '@stern-ui/ui';

// Custom theme overrides for the Alert component styling
const severityOptions = {
	info: {
		iconBg: 'bg-white',
		background: 'bg-primaryBrandBackground',
	},
};

export const Alert = (props: AlertProps) => {
	return <AlertSharedComponent {...props} severityOptionsOverrides={severityOptions} />;
};
